import { Typography } from '@material-ui/core'
import React  from 'react'

const MainScreen = () => {

  return (
    <React.Fragment  >
      <Typography variant="h1" >Welcome</Typography>
    </React.Fragment>
  )
}

export default MainScreen
